<template>
  <div>
    <div class="page-content mt-90">
      <template v-if="showMedia">
        <SectionTitle title="最新动态" titleEN="What's New" />
        <div class="news-list mt-50">
          <nuxt-link class="news-item-container" v-for="item in displayItems" :key="item.id" :to="'/html/news/detail/' + item.id + '/'">
            <www-picture
              class="news-img"
              :w="378 * 2"
              :h="206 * 2"
              :img="item.img"
              :noCompress="!!item.scale"
              :objectFit="item.scale || 'cover'"
            />
            <div class="news-title">{{ item.title }}</div>
          </nuxt-link>
        </div>
      </template>
      <template v-else>
        <SectionTitle title="数据报告" titleEN="Industry & Report" />
        <div class="news-list mt-50">
          <div class="news-item-container" v-for="item in displayItemsData" :key="item.id" @click="openDataDetail(item)">
            <www-picture class="news-img" w="378" h="206" :img="item.logImage" />
            <div class="data-title">{{ item.title }}</div>
            <div class="data-desc">{{ item.reportDesc }}</div>
          </div>
        </div>
      </template>
    </div>
    <img src="//img.souche.com/f2e/b96d02084431847d8fefc14057a50543.svg" class="back-top" ref="backTopEl" @click.stop="backTop" />
  </div>
</template>

<script>
import MyFooter from "../../../../components/MyFooter.vue";
import SectionTitle from "../../../../components/SectionTitle.vue";
import Pagination from "../../../../components/Pagination.vue";
import { getAllDataReportTypeList } from "../../../../api/index";
import moment from "moment";
import { generateImageJpg, generateImageWebp } from "../../../../utils/image";

import { media as newsDataMedia, official as newsDataOfficial } from "../../../../data/news";

export default {
  data() {
    return {
      type: 1,
      newsDataMedia,
      newsDataOfficial,
      dataReport: [],
    };
  },
  computed: {
    showMedia() {
      return this.type == 1;
    },
    displayItemsData() {
      return this.dataReport;
    },
    displayItems() {
      return this.newsDataMedia;
    },
  },
  methods: {
    generateImageJpg,
    generateImageWebp,
    openDataDetail(detail) {
      window.open(`https://zhiyun.souche.com/dataReport/dataReportDetail?id=${detail.id}`, `souche-report-detail-${detail.id}`);
    },
    getData() {
      getAllDataReportTypeList({
        endMonth: moment().format("YYYY-MM-DD"),
        startMonth: moment().subtract(12, "M").format("YYYY-MM-DD"),
        pageSize: 500,
        currentPage: 1,
      })
        .then((res) => {
          this.dataReport = res.items || [];
        })
        .catch(console.log);
    },
    onScroll() {
      if (document.scrollingElement.scrollTop > window.innerHeight) {
        if (this.add) {
          return;
        }
        this.add = true;
        this.$refs.backTopEl.classList.add("back-top-show");
      } else {
        if (!this.add) {
          return;
        }
        this.add = false;
        this.$refs.backTopEl.classList.remove("back-top-show");
      }
    },
    backTop() {
      document.scrollingElement.scrollBy({ top: -document.scrollingElement.scrollTop, behavior: "smooth" });
    },
  },

  mounted() {
    this.onScroll = this.onScroll.bind(this);
    const query = window.location.href.split("?")[1];
    const mt = query && query.match(/type=(\d)/);
    if (mt) {
      this.type = mt[1] || 1;
    }
    window.addEventListener("scroll", this.onScroll);
    if (!this.showMedia) {
      this.getData();
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  components: {
    MyFooter,
    SectionTitle,
    Pagination,
  },
  i18n: {
    messages: {
      zh: {
        title: "新闻动态",
        titleData: "数据报告",
        OfficialReport: "官方新闻",
        MediaReport: "媒体报道",
      },
      en: {
        title: "NEWS",
        titleData: "数据报告",
        OfficialReport: "Official Report",
        MediaReport: "Media Report",
      },
    },
  },
  head() {
    return {
      title: this.$t("title"),
    };
  },
};
</script>

<style lang="less" scoped>
.pagination {
  margin-top: 44px;
}

.media-resource {
  background: linear-gradient(238.88deg, #ffd9cb 0%, rgba(255, 217, 203, 0) 44.73%);
  padding: 82px 0 182px 0;
  flex-direction: column;

  .list {
    display: grid;
    margin-top: 39px;
    overflow: hidden;
    grid-template-columns: 214px 214px 214px 214px 214px;
    column-gap: 32px;
    padding-bottom: 68px;

    .item {
      width: 214px;
      height: 96px;
      box-sizing: border-box;
      overflow: hidden;
      background: linear-gradient(180deg, #fcfbfa 0%, #ffffff 100%);
      box-shadow: 1px 5px 12px #f3ebe8;
      border-radius: 4px;
      padding: 14px 32px;
    }
  }

  .tip {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #2b2c2e;
  }
}

.news-list {
  display: flex;
  flex-direction: column;

  .news-item-container {
    display: flex;
    flex-direction: column;
    text-decoration: none;
    width: 100%;
    overflow: hidden;
    text-decoration: none;
    background-color: linear-gradient(180deg, #f6f7fb 0%, #ffffff 100%);
    box-shadow: 1px 2px 6px #f4f1f0;
    border-radius: 3px;
    margin-bottom: 16px;

    .news-img {
      overflow: hidden;
      display: flex;
      width: 100%;
      height: calc((100vw - 32px) * (206 / 378));
    }

    .news-title,
    .data-title {
      margin: 16px 16px 0px 16px;
      -webkit-line-clamp: 1;
      overflow: hidden;
      color: #2b2c2e;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 21px;
    }
    .news-title {
      margin: 16px;
    }

    .data-desc {
      font-weight: 400;
      font-size: 11px;
      line-height: 19px;
      margin: 0px 16px 16px 16px;
    }

    .data-desc {
      font-weight: 400;
      font-size: 11px;
      line-height: 19px;
      margin: 0px 16px 16px 16px;
      font-style: normal;
      color: #b4b5b7;
      text-overflow: ellipsis;
      /* autoprefixer: off */
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}

.back-top {
  position: fixed;
  width: 40px;
  height: 40px;
  z-index: 10;
  right: 16px;
  bottom: 35px;
  transform: translateY(80px);
  transition: transform 0.3s;

  &-show {
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/_lang/html/news/all.vue